import Typography from "@mui/material/Typography";

export default function Title({ val }) {
  return (
    <Typography gutterBottom sx={{ typography: {xs: 'h6', md: 'h5'} }} component="div">
      {val}
    </Typography>
  );
}
